export default __webpack_public_path__ + "static/media/logo.fd037f7b.png";